import axios, { AxiosResponse, AxiosError } from "axios";
import i18next from "i18next";
import { CustomAxiosError } from "../../services/types";

const isNetworkError = (error: unknown): error is AxiosError => {
  return axios.isAxiosError(error) && (!error.response || error.code === AxiosError.ERR_NETWORK || error.message === "Network Error");
};

const fromGraphqlResponse = (res: AxiosResponse) => {
  if (res.data && res.data.errors && res.data.errors[0] && res.data.errors[0].extensions && res.data.errors[0].extensions.code) {
    const message = JSON.stringify(res.data.errors[0]);
    throw new Error(message);
  }

  if (res.data && res.data.errors) {
    const errorMessage = res.data.errors[0].message;
    throw new Error(errorMessage);
  }
  return res.data;
};

const fromGraphqlError = (error: unknown) => {
  if (isNetworkError(error)) {
    throw new Error(i18next.t("common:errors.networkError", "Network"));
  }

  const res = error as CustomAxiosError;

  if (res.response?.data?.errors?.[0]) {
    const firstError = res.response.data.errors[0];

    if (firstError.extensions?.code) {
      const message = JSON.stringify(firstError);
      throw new Error(message);
    }

    if (firstError.message) {
      throw new Error(firstError.message);
    }
  }
  throw new Error(i18next.t("common:errors.clientError"));
};

const fromRestApiResponse = (response: AxiosResponse) => {
  const { data } = response;
  if (data && data.errors) {
    const errorMessage = data.errors[0].message;
    throw new Error(errorMessage);
  }
  return data;
};

const fromRestApiError = (res: CustomAxiosError) => {
  const { response } = res;
  if (response && response.data && response.data.errors) {
    throw new Error(response.data.errors[0]?.message);
  }
  throw Error(i18next.t("common:errors.clientError"));
};

const serviceResultFactory = {
  fromGraphqlResponse,
  fromGraphqlError,
  fromRestApiResponse,
  fromRestApiError
};

export default serviceResultFactory;
